export default __webpack_public_path__ + "static/media/adventure-banner.26229d12.jpeg";